var $7b3e693b22bacbe1$exports = {};
$7b3e693b22bacbe1$exports = {
    "endTime": `\u{7ED3}\u{675F}\u{65F6}\u{95F4}`,
    "startTime": `\u{5F00}\u{59CB}\u{65F6}\u{95F4}`,
    "time": `\u{65F6}\u{95F4}`
};


export {$7b3e693b22bacbe1$exports as default};
//# sourceMappingURL=zh-CN.mjs.map
